<template>
  <div class="container">
    <div class="row">
      <div class="col-12 mt-4">
        <h2 v-if="!isSentFeedback">
          {{ $t('unsubscribe.confirm') }}
        </h2>
        <div v-if="isSentFeedback">
          <font-awesome-icon
            class="text-custom"
            style="font-size: 66px;"
            :icon="['fas', 'check-circle']"
          />
          <h2>
            {{ $t('unsubscribe.successTitle') }}
            <br />
          </h2>
          <h4>
            {{ $t('unsubscribe.successSentFeedback') }}
            <br />
          </h4>
        </div>

        <hr />
      </div>
    </div>

    <div class="row" v-if="!isSentFeedback">
      <div class="col-12 mt-10 p-20 custom">
        <h5>
          {{ $t('unsubscribe.successSubTitle') }}
        </h5>
        <br />
        <b-form-group label="" v-slot="{ ariaDescribedby }">
          <b-form-radio
            v-for="(item, i) in reasons"
            :key="i"
            v-model="selectedReason"
            :aria-describedby="ariaDescribedby"
            name="reason"
            :value="item"
            size="lg"
            style="margin-bottom: 12px;"
            >{{ $t(`unsubscribe.reasons.${item}`) }}</b-form-radio
          >
        </b-form-group>

        <button @click="sendFeedback" class="btn btn-custom btn-shadow">
          Confirmar e remover meu email
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../services/api';

export default {
  data: () => ({
    isSentFeedback: false,
    isLoading: false,
    selectedReason: null,
    inviteId: null,
    reasons: [
      'dontReceiveEmails',
      'notInterested',
      'dontAllowReceiving',
      'other',
    ],
  }),

  created() {
    this.inviteId = this.$route.params.inviteId;
  },

  methods: {
    sendFeedback() {
      api
        .post(`/blacklist/email/${this.inviteId}`, {
          reason: this.$t(`unsubscribe.reasons.${this.selectedReason}`) || null,
        })
        .then(() => {
          this.isSentFeedback = true;
        })
        .catch((err) => {
          window.console.log('Error -> ', err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-shadow {
  -webkit-box-shadow: 0px 10px 30px -7px #9000ff;
  box-shadow: 0px 10px 30px -7px #9000ff;
}
.btn-custom {
  background: #9000ff;
  color: #ffffff;
}
.text-custom {
  color: #9000ff;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #9000ff;
  background-color: #9000ff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/unsubscribe-email/index.vue